import { render, staticRenderFns } from "./EditJobButton.vue?vue&type=template&id=6039c23c&"
import script from "./EditJobButton.vue?vue&type=script&lang=js&"
export * from "./EditJobButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports